var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"name":"description","api-key":"f9tg25pq47z4zweve160g3wt475r0oycir62ddltkzsd8v6w","init":{
      selector: 'textarea',
      height: 350,
      menubar: 'file edit insert view format table tools help',
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount toc'
      ],
      toolbar:
        'undo redo | formatselect | bold italic underline code backcolor | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent | removeformat | help | toc'
    },"initial-value":_vm.value},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }